// 도형·패턴 영역 (총 40문항)
// 기본 도형 인지 → 매트릭스 → 도형 겹치기 매트릭스 → 테트리스 → 쌓기나무 → 3D 입체 회전 순

export const iqPatternQuestions = [
  {
    id: 1,
    category: 'pattern',
    question: '빈칸(?)에 들어갈 도형은?',
    visualType: 'matrix2x2',
    visualData: {
      matrix: [
        ['○', '○○'],
        ['△', '?']
      ]
    },
    options: ['△', '○○', '△△', '□□'],
    answer: 2,
    explanation: '가로 방향으로 같은 도형의 개수가 1개에서 2개로 늘어납니다. △ 다음은 △△입니다.',
  },
  {
    id: 2,
    category: 'pattern',
    question: '빈칸(?)에 들어갈 도형은?',
    visualType: 'shapeSequence',
    visualData: {
      items: ['◆', '◇', '◆', '◇', '◆', '◇', '◆', '?']
    },
    options: ['◆', '◇', '○', '●'],
    answer: 1,
    explanation: '◆와 ◇가 번갈아 나타나는 규칙입니다. ◆ 다음에는 ◇가 옵니다.',
  },
  {
    id: 3,
    category: 'pattern',
    question: '빈칸(?)에 들어갈 도형은?',
    visualType: 'arrowSequence',
    visualData: {
      items: ['┌', '┐', '┘', '?']
    },
    options: ['┌', '─', '│', '└'],
    answer: 3,
    explanation: 'ㄱ자 도형이 시계방향으로 90°씩 회전합니다. ┘ 다음에는 └가 옵니다.',
  },
  {
    id: 4,
    category: 'pattern',
    question: '빈칸(?)에 들어갈 도형은?',
    visualType: 'shapeSequence',
    visualData: {
      items: ['△', '□', '⬠', '?']
    },
    options: ['⬡', '◇', '○', '⬠'],
    answer: 0,
    explanation: '변의 개수가 3, 4, 5, 6으로 하나씩 늘어납니다. 다음은 육각형(⬡)입니다.',
  },
  {
    id: 5,
    category: 'pattern',
    question: '',
    visualType: 'shapeSequence',
    visualData: {
      items: ['■□□□', '□■□□', '□□■□', '?']
    },
    options: ['□■□□', '□□■□', '■□□□', '□□□■'],
    answer: 3,
    explanation: '검은 사각형(■)이 한 칸씩 오른쪽으로 이동합니다. 마지막은 네 번째 칸인 □□□■입니다.',
  },
  {
    id: 6,
    category: 'pattern',
    question: '빈칸(?)에 들어갈 도형은?',
    visualType: 'matrix3x3',
    visualData: {
      matrix: [
        ['┌', '┐', '┘'],
        ['┘', '└', '┌'],
        ['┌', '┐', '?']
      ]
    },
    options: ['└', '┘', '┌', '┐'],
    answer: 1,
    explanation: '각 행에서 도형이 시계방향으로 90°씩 회전합니다. ┌→┐→┘이므로 세 번째 행도 ┌→┐→┘입니다.',
  },
  {
    id: 7,
    category: 'pattern',
    question: '빈칸(?)에 들어갈 도형은?',
    visualType: 'matrix3x3',
    visualData: {
      matrix: [
        ['○', '●', '●●'],
        ['□', '■', '■■'],
        ['△', '▲', '?']
      ]
    },
    options: ['▲▲', '▲', '▲▲▲', '■■'],
    answer: 0,
    explanation: '각 행에서 속이 빈 도형 → 채운 도형 → 채운 도형 2개로 진행합니다. △→▲→▲▲입니다.',
  },
  {
    id: 8,
    category: 'pattern',
    question: '빈칸(?)에 들어갈 도형은?',
    visualType: 'matrix3x3',
    visualData: {
      matrix: [
        ['●', '○', '○'],
        ['○', '●', '○'],
        ['○', '○', '?']
      ]
    },
    options: ['○', '●', '⊙', '◐'],
    answer: 1,
    explanation: '검은 점(●)이 대각선을 따라 한 칸씩 이동합니다. 마지막 칸에는 ●가 옵니다.',
  },
  {
    id: 9,
    category: 'pattern',
    question: '빈칸(?)에 들어갈 도형은?',
    visualType: 'matrix3x3',
    visualData: {
      matrix: [
        ['△', '▷', '▽'],
        ['▽', '◁', '△'],
        ['△', '▷', '?']
      ]
    },
    options: ['△', '▷', '▽', '◁'],
    answer: 2,
    explanation: '각 행에서 삼각형이 시계방향으로 90°씩 회전합니다. △→▷→▽이므로 ?는 ▽입니다.',
  },
  {
    id: 10,
    category: 'pattern',
    question: '빈칸(?)에 들어갈 도형은?',
    visualType: 'matrix3x3',
    visualData: {
      matrix: [
        ['△', '□', '○'],
        ['□', '○', '△'],
        ['○', '?', '□']
      ]
    },
    options: ['□', '○', '◇', '△'],
    answer: 3,
    explanation: '각 행과 열에 △, □, ○가 한 번씩만 등장합니다. 세 번째 행에는 △가 빠져 있으므로 ?는 △입니다.',
  },
  {
    id: 11,
    category: 'pattern',
    question: '빈칸(?)에 들어갈 도형은?',
    visualType: 'matrix4x4',
    visualData: {
      matrix: [
        ['■', '□', '□', '□'],
        ['□', '■', '□', '□'],
        ['□', '□', '■', '□'],
        ['□', '□', '□', '?']
      ]
    },
    options: ['□', '■', '○', '△'],
    answer: 1,
    explanation: '검은 사각형(■)이 대각선을 따라 한 칸씩 내려갑니다. 마지막 칸은 ■입니다.',
  },
  {
    id: 12,
    category: 'pattern',
    question: '빈칸(?)에 들어갈 화살표는?',
    visualType: 'matrix4x4',
    visualData: {
      matrix: [
        ['↑', '→', '↓', '←'],
        ['→', '↓', '←', '↑'],
        ['↓', '←', '↑', '→'],
        ['←', '↑', '→', '?']
      ]
    },
    options: ['↑', '→', '←', '↓'],
    answer: 3,
    explanation: '각 행에서 화살표가 왼쪽으로 한 칸씩 이동합니다. 네 번째 행은 ←↑→ 다음에 ↓입니다.',
  },
  {
    id: 13,
    category: 'pattern',
    question: '빈칸(?)에 들어갈 도형은?',
    visualType: 'matrix4x4',
    visualData: {
      matrix: [
        ['○', '△', '□', '◇'],
        ['△', '□', '◇', '○'],
        ['□', '◇', '○', '△'],
        ['◇', '○', '△', '?']
      ]
    },
    options: ['○', '□', '△', '◇'],
    answer: 1,
    explanation: '네 도형이 각 행에서 왼쪽으로 한 칸씩 이동하며 순환합니다. 마지막 칸은 □입니다.',
  },

  /* ── 도형 겹치기 매트릭스 (3×3 표, 1·2행 규칙 → 3행 정답) ── */
  {
    id: 14,
    category: 'pattern',
    question: '1·2행의 규칙을 보고, 빈칸(?)에 들어갈 도형은?',
    visualType: 'overlapMatrix',
    visualData: {
      cells: [
        [[0, 1, 0], [0, 1, 0], [0, 1, 0]],
        [[0, 0, 0], [1, 1, 1], [0, 0, 0]],
        [[0, 1, 0], [1, 0, 1], [0, 1, 0]],
        [[1, 0, 0], [0, 1, 0], [0, 0, 1]],
        [[0, 0, 1], [0, 1, 0], [1, 0, 0]],
        [[1, 0, 1], [0, 0, 0], [1, 0, 1]],
        [[1, 1, 0], [1, 0, 0], [0, 0, 0]],
        [[0, 0, 0], [0, 0, 1], [0, 1, 1]],
        null
      ]
    },
    options: ['①', '②', '③', '④'],
    optionVisualType: 'blockGrid',
    optionVisuals: [
      { grid: [[1, 1, 0], [1, 0, 1], [0, 1, 1]] },
      { grid: [[1, 1, 0], [1, 1, 1], [0, 1, 1]] },
      { grid: [[1, 1, 1], [1, 0, 1], [0, 1, 1]] },
      { grid: [[1, 1, 0], [1, 0, 0], [0, 1, 1]] }
    ],
    answer: 0,
    explanation: '두 도형이 겹친 부분은 사라지는 규칙입니다. 3행에서 두 도형은 겹치지 않으므로 그대로 합쳐집니다.',
  },
  {
    id: 15,
    category: 'pattern',
    question: '1·2행의 규칙을 보고, 빈칸(?)에 들어갈 도형은?',
    visualType: 'overlapMatrix',
    visualData: {
      cells: [
        [[1, 1, 1], [1, 0, 0], [1, 0, 0]],
        [[1, 1, 1], [0, 0, 1], [0, 0, 1]],
        [[1, 1, 1], [0, 0, 0], [0, 0, 0]],
        [[1, 0, 0], [1, 0, 0], [1, 1, 1]],
        [[0, 0, 1], [0, 0, 1], [1, 1, 1]],
        [[0, 0, 0], [0, 0, 0], [1, 1, 1]],
        [[1, 1, 1], [0, 1, 0], [0, 1, 0]],
        [[0, 1, 0], [0, 1, 0], [1, 1, 1]],
        null
      ]
    },
    options: ['①', '②', '③', '④'],
    optionVisualType: 'blockGrid',
    optionVisuals: [
      { grid: [[1, 1, 1], [0, 1, 0], [1, 1, 1]] },
      { grid: [[0, 0, 0], [0, 1, 0], [0, 0, 0]] },
      { grid: [[0, 1, 0], [0, 1, 0], [0, 1, 0]] },
      { grid: [[1, 1, 1], [1, 1, 1], [1, 1, 1]] }
    ],
    answer: 2,
    explanation: '두 도형이 겹친 부분만 남기는 규칙(교집합)입니다. 3행에서 공통되는 가운데 세로줄만 남습니다.',
  },
  {
    id: 16,
    category: 'pattern',
    question: '1·2행의 규칙을 보고, 빈칸(?)에 들어갈 도형은?',
    visualType: 'overlapMatrix',
    visualData: {
      cells: [
        [[1, 1, 1], [0, 1, 0], [0, 0, 0]],
        [[1, 0, 0], [1, 1, 0], [1, 0, 0]],
        [[0, 1, 1], [1, 0, 0], [1, 0, 0]],
        [[0, 0, 0], [0, 1, 0], [1, 1, 1]],
        [[0, 0, 1], [0, 1, 1], [0, 0, 1]],
        [[0, 0, 1], [0, 0, 1], [1, 1, 0]],
        [[1, 0, 0], [0, 1, 0], [0, 0, 1]],
        [[0, 0, 1], [0, 1, 0], [1, 0, 0]],
        null
      ]
    },
    options: ['①', '②', '③', '④'],
    optionVisualType: 'blockGrid',
    optionVisuals: [
      { grid: [[1, 0, 1], [0, 1, 0], [1, 0, 1]] },
      { grid: [[1, 0, 1], [0, 0, 0], [1, 0, 1]] },
      { grid: [[0, 0, 1], [0, 0, 0], [1, 0, 0]] },
      { grid: [[1, 0, 1], [0, 0, 0], [0, 1, 0]] }
    ],
    answer: 1,
    explanation: '겹친 부분이 사라지는 규칙입니다. 두 대각선이 겹친 가운데 칸이 사라져 X자 모양이 됩니다.',
  },
  {
    id: 17,
    category: 'pattern',
    question: '1·2행의 규칙을 보고, 빈칸(?)에 들어갈 도형은?',
    visualType: 'overlapMatrix',
    visualData: {
      cells: [
        [[0, 1, 0], [0, 1, 0], [0, 1, 0]],
        [[0, 0, 0], [1, 1, 1], [0, 0, 0]],
        [[0, 1, 0], [1, 1, 1], [0, 1, 0]],
        [[1, 0, 0], [0, 1, 0], [0, 0, 1]],
        [[0, 0, 1], [0, 1, 0], [1, 0, 0]],
        [[1, 0, 1], [0, 1, 0], [1, 0, 1]],
        [[1, 1, 0], [0, 1, 0], [0, 0, 0]],
        [[0, 0, 0], [0, 1, 0], [0, 1, 1]],
        null
      ]
    },
    options: ['①', '②', '③', '④'],
    optionVisualType: 'blockGrid',
    optionVisuals: [
      { grid: [[1, 1, 0], [0, 1, 0], [0, 1, 1]] },
      { grid: [[1, 1, 0], [0, 0, 0], [0, 1, 1]] },
      { grid: [[1, 1, 0], [0, 1, 1], [0, 1, 1]] },
      { grid: [[1, 1, 1], [0, 1, 0], [0, 1, 1]] }
    ],
    answer: 0,
    explanation: '두 도형을 합치는 규칙(합집합)입니다. 겹친 가운데 칸도 그대로 남습니다.',
  },
  {
    id: 18,
    category: 'pattern',
    question: '1·2행의 규칙을 보고, 빈칸(?)에 들어갈 도형은?',
    visualType: 'overlapMatrix',
    visualData: {
      cells: [
        [[1, 1, 1], [1, 1, 1], [1, 1, 1]],
        [[0, 0, 0], [0, 1, 0], [0, 0, 0]],
        [[1, 1, 1], [1, 0, 1], [1, 1, 1]],
        [[1, 1, 1], [1, 1, 0], [1, 0, 0]],
        [[1, 1, 1], [0, 0, 0], [0, 0, 0]],
        [[0, 0, 0], [1, 1, 0], [1, 0, 0]],
        [[1, 1, 1], [1, 0, 0], [1, 0, 0]],
        [[1, 0, 0], [1, 0, 0], [1, 0, 0]],
        null
      ]
    },
    options: ['①', '②', '③', '④'],
    optionVisualType: 'blockGrid',
    optionVisuals: [
      { grid: [[1, 1, 1], [1, 0, 0], [1, 0, 0]] },
      { grid: [[1, 1, 1], [0, 0, 0], [0, 0, 0]] },
      { grid: [[0, 0, 0], [0, 0, 0], [1, 1, 1]] },
      { grid: [[0, 1, 1], [0, 0, 0], [0, 0, 0]] }
    ],
    answer: 3,
    explanation: '왼쪽 도형에서 오른쪽 도형을 빼는 규칙입니다. A에서 B(세로줄)를 빼면 맨 윗줄 오른쪽 두 칸만 남습니다.',
  },
  {
    id: 19,
    category: 'pattern',
    question: '1·2행의 규칙을 보고, 빈칸(?)에 들어갈 도형은?',
    visualType: 'overlapMatrix',
    visualData: {
      cells: [
        [[1, 1, 1], [0, 1, 0], [0, 1, 0]],
        [[0, 1, 0], [1, 1, 1], [0, 1, 0]],
        [[0, 1, 0], [0, 1, 0], [0, 1, 0]],
        [[1, 0, 0], [1, 1, 1], [0, 0, 1]],
        [[0, 0, 1], [1, 1, 1], [1, 0, 0]],
        [[0, 0, 0], [1, 1, 1], [0, 0, 0]],
        [[1, 1, 1], [0, 0, 1], [0, 0, 1]],
        [[1, 1, 1], [1, 0, 0], [1, 0, 0]],
        null
      ]
    },
    options: ['①', '②', '③', '④'],
    optionVisualType: 'blockGrid',
    optionVisuals: [
      { grid: [[1, 1, 1], [1, 0, 1], [1, 0, 1]] },
      { grid: [[1, 1, 1], [0, 0, 0], [0, 0, 0]] },
      { grid: [[0, 0, 0], [0, 0, 0], [0, 0, 0]] },
      { grid: [[1, 0, 0], [1, 0, 0], [1, 1, 1]] }
    ],
    answer: 1,
    explanation: '겹친 부분만 남기는 규칙입니다. 두 도형의 공통부분인 맨 윗줄만 남습니다.',
  },
  {
    id: 20,
    category: 'pattern',
    question: '1·2행의 규칙을 보고, 빈칸(?)에 들어갈 도형은?',
    visualType: 'overlapMatrix',
    visualData: {
      cells: [
        [[1, 1, 0], [1, 1, 0], [0, 0, 0]],
        [[0, 0, 0], [0, 1, 1], [0, 1, 1]],
        [[1, 1, 0], [1, 0, 1], [0, 1, 1]],
        [[0, 0, 0], [0, 1, 1], [0, 1, 1]],
        [[0, 1, 1], [0, 1, 1], [0, 0, 0]],
        [[0, 1, 1], [0, 0, 0], [0, 1, 1]],
        [[1, 1, 1], [0, 1, 0], [0, 0, 0]],
        [[0, 0, 1], [0, 1, 1], [0, 0, 1]],
        null
      ]
    },
    options: ['①', '②', '③', '④'],
    optionVisualType: 'blockGrid',
    optionVisuals: [
      { grid: [[1, 1, 0], [0, 0, 1], [0, 0, 1]] },
      { grid: [[1, 1, 1], [0, 1, 1], [0, 0, 1]] },
      { grid: [[1, 1, 0], [0, 0, 0], [0, 0, 1]] },
      { grid: [[0, 1, 0], [0, 0, 1], [0, 0, 1]] }
    ],
    answer: 0,
    explanation: '겹친 부분이 사라지는 규칙입니다. 두 도형을 합친 뒤 겹친 두 칸이 사라집니다.',
  },
  {
    id: 21,
    category: 'pattern',
    question: '1·2행의 규칙을 보고, 빈칸(?)에 들어갈 도형은?',
    visualType: 'overlapMatrix',
    visualData: {
      cells: [
        [[1, 0, 0], [0, 1, 0], [0, 0, 1]],
        [[0, 0, 1], [0, 1, 0], [1, 0, 0]],
        [[1, 0, 1], [0, 1, 0], [1, 0, 1]],
        [[1, 1, 1], [0, 0, 0], [0, 0, 0]],
        [[1, 0, 0], [1, 0, 0], [1, 0, 0]],
        [[1, 1, 1], [1, 0, 0], [1, 0, 0]],
        [[0, 1, 0], [1, 1, 1], [0, 1, 0]],
        [[1, 0, 0], [0, 1, 0], [0, 0, 1]],
        null
      ]
    },
    options: ['①', '②', '③', '④'],
    optionVisualType: 'blockGrid',
    optionVisuals: [
      { grid: [[1, 1, 0], [1, 0, 1], [0, 1, 1]] },
      { grid: [[0, 1, 0], [1, 1, 1], [0, 1, 0]] },
      { grid: [[1, 1, 0], [1, 1, 1], [0, 1, 1]] },
      { grid: [[1, 1, 1], [1, 1, 1], [1, 1, 1]] }
    ],
    answer: 2,
    explanation: '두 도형을 합치는 규칙(합집합)입니다. 십자(+)와 대각선을 합치면 7칸이 채워집니다.',
  },

  /* ── 3차원 입체 겹치기 (3×3 표, 1·2행 규칙 → 3행 정답) ── */
  {
    id: 22,
    category: 'pattern',
    question: '1·2행의 규칙을 보고, 빈칸(?)에 들어갈 3차원 입체는?',
    visualType: 'overlapMatrix3D',
    visualData: {
      solids: [
        [[0,0,0],[0,0,1],[1,0,0],[1,0,1]],
        [[1,0,0],[1,0,1],[2,0,0],[2,0,1]],
        [[0,0,0],[0,0,1],[2,0,0],[2,0,1]],
        [[0,0,0],[0,0,1],[0,1,0],[0,1,1]],
        [[0,1,0],[0,1,1],[0,2,0],[0,2,1]],
        [[0,0,0],[0,0,1],[0,2,0],[0,2,1]],
        [[0,0,0],[0,0,1],[1,1,0],[1,1,1]],
        [[1,1,0],[1,1,1],[2,2,0],[2,2,1]],
        null
      ]
    },
    options: ['①', '②', '③', '④'],
    optionVisualType: 'solidView',
    optionVisuals: [
      { solid: [[0,0,0],[0,0,1],[2,2,0],[2,2,1]] },
      { solid: [[0,0,0],[0,0,1],[1,1,0],[1,1,1],[2,2,0],[2,2,1]] },
      { solid: [[0,0,0],[2,2,0]] },
      { solid: [[1,1,0],[1,1,1]] }
    ],
    answer: 0,
    explanation: '두 입체가 겹치는 부분이 사라지는 규칙(XOR)입니다. 3행에서 겹치는 가운데(1,1) 기둥이 사라져 왼쪽 위와 오른쪽 아래 기둥만 남습니다.',
  },
  {
    id: 23,
    category: 'pattern',
    question: '1·2행의 규칙을 보고, 빈칸(?)에 들어갈 3차원 입체는?',
    visualType: 'overlapMatrix3D',
    visualData: {
      solids: [
        [[0,0,0],[0,0,1],[1,0,0],[1,0,1],[0,1,0],[0,1,1]],
        [[1,0,0],[1,0,1],[2,0,0],[2,0,1],[1,1,0],[1,1,1]],
        [[1,0,0],[1,0,1]],
        [[0,0,0],[0,0,1],[0,1,0],[0,1,1],[0,2,0],[0,2,1]],
        [[0,1,0],[0,1,1],[1,1,0],[1,1,1],[2,1,0],[2,1,1]],
        [[0,1,0],[0,1,1]],
        [[0,0,0],[0,0,1],[1,1,0],[1,1,1],[2,2,0],[2,2,1]],
        [[0,2,0],[0,2,1],[1,1,0],[1,1,1],[2,0,0],[2,0,1]],
        null
      ]
    },
    options: ['①', '②', '③', '④'],
    optionVisualType: 'solidView',
    optionVisuals: [
      { solid: [[1,1,0],[1,1,1]] },
      { solid: [[0,0,0],[0,0,1],[1,1,0],[1,1,1],[2,2,0],[2,2,1]] },
      { solid: [[0,2,0],[0,2,1],[1,1,0],[1,1,1],[2,0,0],[2,0,1]] },
      { solid: [[1,1,0]] }
    ],
    answer: 0,
    explanation: '두 입체가 겹치는 부분만 남기는 규칙(교집합)입니다. 3행에서 두 대각선이 공통으로 겹치는 가운데 기둥(1,1)만 남습니다.',
  },
  {
    id: 24,
    category: 'pattern',
    question: '1·2행의 규칙을 보고, 빈칸(?)에 들어갈 3차원 입체는?',
    visualType: 'overlapMatrix3D',
    visualData: {
      solids: [
        [[0,0,0],[0,0,1],[1,0,0],[1,0,1],[2,0,0],[2,0,1]],
        [[1,0,0],[1,0,1],[1,1,0],[1,1,1],[1,2,0],[1,2,1]],
        [[0,0,0],[0,0,1],[2,0,0],[2,0,1],[1,1,0],[1,1,1],[1,2,0],[1,2,1]],
        [[0,0,0],[0,0,1],[0,1,0],[0,1,1],[0,2,0],[0,2,1]],
        [[0,1,0],[0,1,1],[1,1,0],[1,1,1],[2,1,0],[2,1,1]],
        [[0,0,0],[0,0,1],[0,2,0],[0,2,1],[1,1,0],[1,1,1],[2,1,0],[2,1,1]],
        [[0,2,0],[0,2,1],[1,2,0],[1,2,1],[2,2,0],[2,2,1]],
        [[2,0,0],[2,0,1],[2,1,0],[2,1,1],[2,2,0],[2,2,1]],
        null
      ]
    },
    options: ['①', '②', '③', '④'],
    optionVisualType: 'solidView',
    optionVisuals: [
      { solid: [[0,2,0],[0,2,1],[1,2,0],[1,2,1],[2,2,0],[2,2,1]] },
      { solid: [[0,2,0],[0,2,1],[1,2,0],[1,2,1],[2,0,0],[2,0,1],[2,1,0],[2,1,1]] },
      { solid: [[2,0,0],[2,0,1],[2,1,0],[2,1,1],[2,2,0],[2,2,1]] },
      { solid: [[0,2,0],[0,2,1],[1,2,0],[1,2,1],[2,0,0],[2,0,1],[2,1,0],[2,1,1],[2,2,0],[2,2,1]] }
    ],
    answer: 1,
    explanation: '겹치는 부분이 사라지는 규칙입니다. 3행에서 두 입체가 겹친 (2,2) 기둥이 사라집니다.',
  },
  {
    id: 25,
    category: 'pattern',
    question: '1·2행의 규칙을 보고, 빈칸(?)에 들어갈 3차원 입체는?',
    visualType: 'overlapMatrix3D',
    visualData: {
      solids: [
        [[0,0,0],[0,0,1],[1,0,0],[1,0,1]],
        [[1,0,0],[1,0,1],[2,0,0],[2,0,1]],
        [[0,0,0],[0,0,1],[1,0,0],[1,0,1],[2,0,0],[2,0,1]],
        [[0,0,0],[0,0,1],[0,1,0],[0,1,1]],
        [[0,1,0],[0,1,1],[0,2,0],[0,2,1]],
        [[0,0,0],[0,0,1],[0,1,0],[0,1,1],[0,2,0],[0,2,1]],
        [[0,0,0],[0,0,1],[1,1,0],[1,1,1],[2,2,0],[2,2,1]],
        [[0,2,0],[0,2,1],[1,1,0],[1,1,1],[2,0,0],[2,0,1]],
        null
      ]
    },
    options: ['①', '②', '③', '④'],
    optionVisualType: 'solidView',
    optionVisuals: [
      { solid: [[0,0,0],[0,0,1],[1,1,0],[1,1,1],[2,2,0],[2,2,1],[0,2,0],[0,2,1],[2,0,0],[2,0,1]] },
      { solid: [[1,1,0],[1,1,1]] },
      { solid: [[0,0,0],[0,0,1],[1,1,0],[1,1,1],[2,2,0],[2,2,1]] },
      { solid: [[0,2,0],[0,2,1],[1,1,0],[1,1,1],[2,0,0],[2,0,1]] }
    ],
    answer: 0,
    explanation: '두 입체를 합치는 규칙(합집합)입니다. 3행에서 두 대각선 기둥을 합쳐 X자 모양이 됩니다.',
  },

  /* ── 3차원 입체 겹치기 (계속) ── */
  {
    id: 26,
    category: 'pattern',
    question: '1·2행의 규칙을 보고, 빈칸(?)에 들어갈 3차원 입체는?',
    visualType: 'overlapMatrix3D',
    visualData: {
      solids: [
        [[0,0,0],[0,0,1],[1,0,0],[1,0,1],[2,0,0],[2,0,1]],
        [[1,0,0],[1,0,1]],
        [[0,0,0],[0,0,1],[2,0,0],[2,0,1]],
        [[0,0,0],[0,0,1],[1,1,0],[1,1,1],[2,2,0],[2,2,1]],
        [[1,1,0],[1,1,1]],
        [[0,0,0],[0,0,1],[2,2,0],[2,2,1]],
        [[0,0,0],[0,0,1],[1,0,0],[1,0,1],[2,0,0],[2,0,1],[1,1,0],[1,1,1]],
        [[1,0,0],[1,0,1]],
        null
      ]
    },
    options: ['①', '②', '③', '④'],
    optionVisualType: 'solidView',
    optionVisuals: [
      { solid: [[0,0,0],[0,0,1],[2,0,0],[2,0,1],[1,1,0],[1,1,1]] },
      { solid: [[0,0,0],[0,0,1],[1,0,0],[1,0,1],[2,0,0],[2,0,1],[1,1,0],[1,1,1]] },
      { solid: [[0,0,0],[0,0,1],[2,0,0],[2,0,1]] },
      { solid: [[0,0,0],[0,0,1],[1,0,0],[1,0,1],[2,0,0],[2,0,1]] }
    ],
    answer: 0,
    explanation: '왼쪽 입체에서 오른쪽 입체를 빼는 규칙입니다. 3행에서 (1,0) 기둥을 빼면 됩니다.',
  },
  {
    id: 27,
    category: 'pattern',
    question: '1·2행의 규칙을 보고, 빈칸(?)에 들어갈 3차원 입체는?',
    visualType: 'overlapMatrix3D',
    visualData: {
      solids: [
        [[0,0,0],[0,0,1],[1,0,0],[1,0,1],[2,0,0],[2,0,1],[0,1,0],[0,1,1],[1,1,0],[1,1,1],[2,1,0],[2,1,1]],
        [[0,1,0],[0,1,1],[1,1,0],[1,1,1],[2,1,0],[2,1,1],[0,2,0],[0,2,1],[1,2,0],[1,2,1],[2,2,0],[2,2,1]],
        [[0,1,0],[0,1,1],[1,1,0],[1,1,1],[2,1,0],[2,1,1]],
        [[0,0,0],[0,0,1],[0,1,0],[0,1,1],[0,2,0],[0,2,1],[1,0,0],[1,0,1],[1,1,0],[1,1,1],[1,2,0],[1,2,1]],
        [[1,0,0],[1,0,1],[1,1,0],[1,1,1],[1,2,0],[1,2,1],[2,0,0],[2,0,1],[2,1,0],[2,1,1],[2,2,0],[2,2,1]],
        [[1,0,0],[1,0,1],[1,1,0],[1,1,1],[1,2,0],[1,2,1]],
        [[0,0,0],[0,0,1],[1,0,0],[1,0,1],[2,0,0],[2,0,1],[0,1,0],[0,1,1],[1,1,0],[1,1,1],[2,1,0],[2,1,1]],
        [[0,0,0],[0,0,1],[0,1,0],[0,1,1],[0,2,0],[0,2,1],[1,0,0],[1,0,1],[1,1,0],[1,1,1],[1,2,0],[1,2,1]],
        null
      ]
    },
    options: ['①', '②', '③', '④'],
    optionVisualType: 'solidView',
    optionVisuals: [
      { solid: [[0,0,0],[0,0,1],[1,0,0],[1,0,1],[0,1,0],[0,1,1],[1,1,0],[1,1,1]] },
      { solid: [[0,0,0],[0,0,1],[1,0,0],[1,0,1],[2,0,0],[2,0,1],[0,1,0],[0,1,1],[1,1,0],[1,1,1],[2,1,0],[2,1,1]] },
      { solid: [[0,0,0],[0,0,1],[0,1,0],[0,1,1],[0,2,0],[0,2,1],[1,0,0],[1,0,1],[1,1,0],[1,1,1],[1,2,0],[1,2,1]] },
      { solid: [[0,0,0],[0,0,1],[1,1,0],[1,1,1]] }
    ],
    answer: 0,
    explanation: '겹치는 부분만 남기는 규칙(교집합)입니다. 3행에서 두 입체의 공통부분인 왼쪽 위 2×2 블록만 남습니다.',
  },
  {
    id: 28,
    category: 'pattern',
    question: '1·2행의 규칙을 보고, 빈칸(?)에 들어갈 3차원 입체는?',
    visualType: 'overlapMatrix3D',
    visualData: {
      solids: [
        [[0,0,0],[0,0,1],[1,0,0],[1,0,1],[2,0,0],[2,0,1],[1,1,0],[1,1,1]],
        [[0,1,0],[0,1,1],[1,1,0],[1,1,1],[2,1,0],[2,1,1],[1,0,0],[1,0,1]],
        [[0,0,0],[0,0,1],[2,0,0],[2,0,1],[0,1,0],[0,1,1],[2,1,0],[2,1,1]],
        [[0,0,0],[0,0,1],[1,0,0],[1,0,1],[0,1,0],[0,1,1],[1,1,0],[1,1,1]],
        [[1,0,0],[1,0,1],[2,0,0],[2,0,1],[1,1,0],[1,1,1],[2,1,0],[2,1,1]],
        [[0,0,0],[0,0,1],[0,1,0],[0,1,1],[2,0,0],[2,0,1],[2,1,0],[2,1,1]],
        [[0,0,0],[0,0,1],[1,0,0],[1,0,1],[2,0,0],[2,0,1],[0,1,0],[0,1,1],[1,1,0],[1,1,1],[2,1,0],[2,1,1]],
        [[1,0,0],[1,0,1],[1,1,0],[1,1,1],[1,2,0],[1,2,1]],
        null
      ]
    },
    options: ['①', '②', '③', '④'],
    optionVisualType: 'solidView',
    optionVisuals: [
      { solid: [[0,0,0],[0,0,1],[1,0,0],[1,0,1],[2,0,0],[2,0,1],[0,1,0],[0,1,1],[1,1,0],[1,1,1],[2,1,0],[2,1,1]] },
      { solid: [[1,0,0],[1,0,1],[1,1,0],[1,1,1],[1,2,0],[1,2,1]] },
      { solid: [[0,0,0],[0,0,1],[2,0,0],[2,0,1],[0,1,0],[0,1,1],[2,1,0],[2,1,1],[1,2,0],[1,2,1]] },
      { solid: [[0,0,0],[0,0,1],[2,0,0],[2,0,1],[0,1,0],[0,1,1],[2,1,0],[2,1,1]] }
    ],
    answer: 2,
    explanation: '겹치는 부분이 사라지는 규칙입니다. 3행에서 겹친 가운데 기둥 2개가 사라지고, 아래쪽 기둥(1,2)만 새로 남습니다.',
  },

  /* ── 3차원 입체 겹치기 (계속) ── */
  {
    id: 29,
    category: 'pattern',
    question: '1·2행의 규칙을 보고, 빈칸(?)에 들어갈 3차원 입체는?',
    visualType: 'overlapMatrix3D',
    visualData: {
      solids: [
        [[0,0,0],[0,0,1],[1,0,0],[1,0,1]],
        [[0,1,0],[0,1,1],[1,1,0],[1,1,1]],
        [[0,0,0],[0,0,1],[1,0,0],[1,0,1],[0,1,0],[0,1,1],[1,1,0],[1,1,1]],
        [[0,0,0],[0,0,1],[0,1,0],[0,1,1]],
        [[1,0,0],[1,0,1],[1,1,0],[1,1,1]],
        [[0,0,0],[0,0,1],[1,0,0],[1,0,1],[0,1,0],[0,1,1],[1,1,0],[1,1,1]],
        [[0,0,0],[0,0,1],[1,0,0],[1,0,1],[2,0,0],[2,0,1]],
        [[0,2,0],[0,2,1],[1,2,0],[1,2,1],[2,2,0],[2,2,1]],
        null
      ]
    },
    options: ['①', '②', '③', '④'],
    optionVisualType: 'solidView',
    optionVisuals: [
      { solid: [[0,0,0],[0,0,1],[1,0,0],[1,0,1],[2,0,0],[2,0,1],[0,2,0],[0,2,1],[1,2,0],[1,2,1],[2,2,0],[2,2,1]] },
      { solid: [[0,0,0],[0,0,1],[1,0,0],[1,0,1],[2,0,0],[2,0,1]] },
      { solid: [[0,2,0],[0,2,1],[1,2,0],[1,2,1],[2,2,0],[2,2,1]] },
      { solid: [[0,1,0],[0,1,1],[1,1,0],[1,1,1],[2,1,0],[2,1,1]] }
    ],
    answer: 0,
    explanation: '두 입체를 합치는 규칙(합집합)입니다. 3행에서 윗줄과 아랫줄을 합칩니다.',
  },
  {
    id: 30,
    category: 'pattern',
    question: '1·2행의 규칙을 보고, 빈칸(?)에 들어갈 3차원 입체는?',
    visualType: 'overlapMatrix3D',
    visualData: {
      solids: [
        [[0,0,0],[0,0,1],[0,0,2],[1,1,0],[1,1,1],[1,1,2],[2,2,0],[2,2,1],[2,2,2]],
        [[1,0,0],[1,0,1],[1,0,2],[1,1,0],[1,1,1],[1,1,2],[1,2,0],[1,2,1],[1,2,2]],
        [[0,0,0],[0,0,1],[0,0,2],[2,2,0],[2,2,1],[2,2,2],[1,0,0],[1,0,1],[1,0,2],[1,2,0],[1,2,1],[1,2,2]],
        [[0,0,0],[0,0,1],[0,0,2],[0,1,0],[0,1,1],[0,1,2],[0,2,0],[0,2,1],[0,2,2]],
        [[0,1,0],[0,1,1],[0,1,2],[1,1,0],[1,1,1],[1,1,2],[2,1,0],[2,1,1],[2,1,2]],
        [[0,0,0],[0,0,1],[0,0,2],[0,2,0],[0,2,1],[0,2,2],[1,1,0],[1,1,1],[1,1,2],[2,1,0],[2,1,1],[2,1,2]],
        [[0,0,0],[0,0,1],[0,0,2],[1,1,0],[1,1,1],[1,1,2],[2,2,0],[2,2,1],[2,2,2],[0,2,0],[0,2,1],[0,2,2],[2,0,0],[2,0,1],[2,0,2]],
        [[1,1,0],[1,1,1],[1,1,2]],
        null
      ]
    },
    options: ['①', '②', '③', '④'],
    optionVisualType: 'solidView',
    optionVisuals: [
      { solid: [[0,0,0],[0,0,1],[0,0,2],[2,2,0],[2,2,1],[2,2,2],[0,2,0],[0,2,1],[0,2,2],[2,0,0],[2,0,1],[2,0,2]] },
      { solid: [[0,0,0],[0,0,1],[0,0,2],[1,1,0],[1,1,1],[1,1,2],[2,2,0],[2,2,1],[2,2,2],[0,2,0],[0,2,1],[0,2,2],[2,0,0],[2,0,1],[2,0,2]] },
      { solid: [[0,0,0],[0,0,1],[0,0,2],[1,1,0],[1,1,1],[1,1,2],[2,2,0],[2,2,1],[2,2,2]] },
      { solid: [[1,1,0],[1,1,1],[1,1,2]] }
    ],
    answer: 0,
    explanation: '겹치는 부분이 사라지는 규칙입니다. 3행에서 X자와 가운데 기둥이 겹친 (1,1) 기둥이 사라져 네 모서리만 남습니다.',
  },
  {
    id: 31,
    category: 'pattern',
    question: '1·2행의 규칙을 보고, 빈칸(?)에 들어갈 3차원 입체는?',
    visualType: 'overlapMatrix3D',
    visualData: {
      solids: [
        [[0,0,0],[0,0,1],[0,0,2],[1,0,0],[1,0,1],[1,0,2],[2,0,0],[2,0,1],[2,0,2],[1,1,0],[1,1,1],[1,1,2]],
        [[0,1,0],[0,1,1],[0,1,2],[1,1,0],[1,1,1],[1,1,2],[2,1,0],[2,1,1],[2,1,2],[1,0,0],[1,0,1],[1,0,2]],
        [[1,0,0],[1,0,1],[1,0,2],[1,1,0],[1,1,1],[1,1,2]],
        [[0,0,0],[0,0,1],[0,0,2],[1,0,0],[1,0,1],[1,0,2],[2,0,0],[2,0,1],[2,0,2],[0,1,0],[0,1,1],[0,1,2],[1,1,0],[1,1,1],[1,1,2],[2,1,0],[2,1,1],[2,1,2]],
        [[1,0,0],[1,0,1],[1,0,2],[1,1,0],[1,1,1],[1,1,2],[1,2,0],[1,2,1],[1,2,2]],
        [[1,0,0],[1,0,1],[1,0,2],[1,1,0],[1,1,1],[1,1,2]],
        [[0,0,0],[0,0,1],[0,0,2],[1,0,0],[1,0,1],[1,0,2],[2,0,0],[2,0,1],[2,0,2],[1,1,0],[1,1,1],[1,1,2],[1,2,0],[1,2,1],[1,2,2]],
        [[0,1,0],[0,1,1],[0,1,2],[1,1,0],[1,1,1],[1,1,2],[2,1,0],[2,1,1],[2,1,2],[1,0,0],[1,0,1],[1,0,2],[1,2,0],[1,2,1],[1,2,2]],
        null
      ]
    },
    options: ['①', '②', '③', '④'],
    optionVisualType: 'solidView',
    optionVisuals: [
      { solid: [[0,0,0],[0,0,1],[0,0,2],[1,0,0],[1,0,1],[1,0,2],[2,0,0],[2,0,1],[2,0,2],[1,1,0],[1,1,1],[1,1,2],[1,2,0],[1,2,1],[1,2,2]] },
      { solid: [[0,1,0],[0,1,1],[0,1,2],[1,1,0],[1,1,1],[1,1,2],[2,1,0],[2,1,1],[2,1,2],[1,0,0],[1,0,1],[1,0,2],[1,2,0],[1,2,1],[1,2,2]] },
      { solid: [[1,0,0],[1,0,1],[1,0,2],[1,1,0],[1,1,1],[1,1,2]] },
      { solid: [[1,0,0],[1,0,1],[1,0,2],[1,1,0],[1,1,1],[1,1,2],[1,2,0],[1,2,1],[1,2,2]] }
    ],
    answer: 3,
    explanation: '겹치는 부분만 남기는 규칙(교집합)입니다. 3행에서 두 입체의 공통부분인 가운데 세로줄 기둥 3개만 남습니다.',
  },
  {
    id: 32,
    category: 'pattern',
    question: '1·2행의 규칙을 보고, 빈칸(?)에 들어갈 3차원 입체는?',
    visualType: 'overlapMatrix3D',
    visualData: {
      solids: [
        [[0,0,0],[0,0,1],[0,0,2],[1,1,0],[1,1,1],[1,1,2],[2,2,0],[2,2,1],[2,2,2]],
        [[0,1,0],[0,1,1],[0,1,2],[1,1,0],[1,1,1],[1,1,2],[2,1,0],[2,1,1],[2,1,2]],
        [[0,0,0],[0,0,1],[0,0,2],[1,1,0],[1,1,1],[1,1,2],[2,2,0],[2,2,1],[2,2,2],[0,1,0],[0,1,1],[0,1,2],[2,1,0],[2,1,1],[2,1,2]],
        [[0,0,0],[0,0,1],[0,0,2],[0,1,0],[0,1,1],[0,1,2],[0,2,0],[0,2,1],[0,2,2]],
        [[1,1,0],[1,1,1],[1,1,2]],
        [[0,0,0],[0,0,1],[0,0,2],[0,1,0],[0,1,1],[0,1,2],[0,2,0],[0,2,1],[0,2,2],[1,1,0],[1,1,1],[1,1,2]],
        [[0,0,0],[0,0,1],[0,0,2],[1,0,0],[1,0,1],[1,0,2],[2,0,0],[2,0,1],[2,0,2]],
        [[1,1,0],[1,1,1],[1,1,2],[2,2,0],[2,2,1],[2,2,2]],
        null
      ]
    },
    options: ['①', '②', '③', '④'],
    optionVisualType: 'solidView',
    optionVisuals: [
      { solid: [[0,0,0],[0,0,1],[0,0,2],[1,0,0],[1,0,1],[1,0,2],[2,0,0],[2,0,1],[2,0,2],[1,1,0],[1,1,1],[1,1,2],[2,2,0],[2,2,1],[2,2,2]] },
      { solid: [[0,0,0],[0,0,1],[0,0,2],[1,0,0],[1,0,1],[1,0,2],[2,0,0],[2,0,1],[2,0,2]] },
      { solid: [[1,1,0],[1,1,1],[1,1,2],[2,2,0],[2,2,1],[2,2,2]] },
      { solid: [[0,0,0],[0,0,1],[0,0,2],[1,1,0],[1,1,1],[1,1,2],[2,2,0],[2,2,1],[2,2,2]] }
    ],
    answer: 0,
    explanation: '두 입체를 합치는 규칙(합집합)입니다. 3행에서 윗줄과 대각선 기둥을 합칩니다.',
  },
  {
    id: 81,
    category: 'pattern',
    question: '각 행에서 2열은 1열을 90° 회전한 모양입니다. 두 도형을 합치는 규칙을 보고, 빈칸(?)에 들어갈 도형은?',
    visualType: 'compositeMatrix',
    visualData: {
      composites: [
        { frame: 'square', lines: ['h'] }, { frame: 'square', lines: ['v'] }, { frame: 'square', lines: ['h', 'v'] },
        { frame: 'square', lines: ['x'] }, { frame: 'square', lines: ['x'] }, { frame: 'square', lines: ['x'] },
        { frame: 'square', lines: ['h', 'x'] }, { frame: 'square', lines: ['v', 'x'] }, null
      ]
    },
    options: ['①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧'],
    optionVisualType: 'compositeShape',
    optionVisuals: [
      { composite: { frame: 'square', lines: ['h', 'v'] } },
      { composite: { frame: 'square', lines: ['x'] } },
      { composite: { frame: 'square', lines: ['+', 'x'] } },
      { composite: { frame: 'square', lines: ['+'] } },
      { composite: { frame: 'circle', lines: ['+', 'x'] } },
      { composite: { frame: 'square', lines: ['h', 'x'] } },
      { composite: { frame: 'square', lines: ['v', 'x'] } },
      { composite: { frame: 'square', lines: ['h'] } }
    ],
    answer: 2,
    explanation: '2열은 1열의 선을 90° 회전한 모양입니다(가로↔세로, X자↔X자). 두 선을 모두 합치는 합집합 규칙이므로 3행은 {h,x} ∪ {v,x} = {h,v,x} = +, x 모양입니다.',
  },
  {
    id: 82,
    category: 'pattern',
    question: '각 행에서 1열에서 2열의 선을 빼는 차집합 규칙입니다. 빈칸(?)에 들어갈 도형은?',
    visualType: 'compositeMatrix',
    visualData: {
      composites: [
        { frame: 'square', lines: ['h', 'v'] }, { frame: 'square', lines: ['v'] }, { frame: 'square', lines: ['h'] },
        { frame: 'square', lines: ['x', '/'] }, { frame: 'square', lines: ['/'] }, { frame: 'square', lines: ['x'] },
        { frame: 'square', lines: ['h', 'v', '/'] }, { frame: 'square', lines: ['/'] }, null
      ]
    },
    options: ['①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧'],
    optionVisualType: 'compositeShape',
    optionVisuals: [
      { composite: { frame: 'square', lines: ['h'] } },
      { composite: { frame: 'square', lines: ['h', 'v'] } },
      { composite: { frame: 'square', lines: ['x'] } },
      { composite: { frame: 'square', lines: ['/'] } },
      { composite: { frame: 'circle', lines: ['h', 'v'] } },
      { composite: { frame: 'square', lines: ['+'] } },
      { composite: { frame: 'square', lines: ['h', '/'] } },
      { composite: { frame: 'square', lines: ['v', '/'] } }
    ],
    answer: 1,
    explanation: '1열에서 2열의 선을 빼는 차집합 규칙입니다. 3행은 {h,v,/} \ {/} = {h,v} 입니다.',
  },
  {
    id: 83,
    category: 'pattern',
    question: '각 행에서 2열은 1열을 90° 회전한 모양입니다. 두 도형을 합치는 규칙을 보고, 빈칸(?)에 들어갈 도형은?',
    visualType: 'compositeMatrix',
    visualData: {
      composites: [
        { frame: 'diamond', lines: ['h'] }, { frame: 'diamond', lines: ['v'] }, { frame: 'diamond', lines: ['h', 'v'] },
        { frame: 'diamond', lines: ['x'] }, { frame: 'diamond', lines: ['x'] }, { frame: 'diamond', lines: ['x'] },
        { frame: 'diamond', lines: ['v', 'x'] }, { frame: 'diamond', lines: ['h', 'x'] }, null
      ]
    },
    options: ['①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧'],
    optionVisualType: 'compositeShape',
    optionVisuals: [
      { composite: { frame: 'diamond', lines: ['+', 'x'] } },
      { composite: { frame: 'diamond', lines: ['h', 'v'] } },
      { composite: { frame: 'diamond', lines: ['x'] } },
      { composite: { frame: 'diamond', lines: ['+'] } },
      { composite: { frame: 'square', lines: ['+', 'x'] } },
      { composite: { frame: 'diamond', lines: ['h', 'x'] } },
      { composite: { frame: 'diamond', lines: ['v', 'x'] } },
      { composite: { frame: 'diamond', lines: ['h'] } }
    ],
    answer: 0,
    explanation: '2열은 1열을 90° 회전한 모양입니다. 두 선을 모두 합치는 합집합 규칙이므로 3행은 {v,x} ∪ {h,x} = {h,v,x} = +, x 모양입니다.',
  },
  {
    id: 84,
    category: 'pattern',
    question: '각 행에서 1열에서 2열의 선을 빼는 차집합 규칙입니다. 빈칸(?)에 들어갈 도형은?',
    visualType: 'compositeMatrix',
    visualData: {
      composites: [
        { frame: 'triangle', lines: ['h', 'v'] }, { frame: 'triangle', lines: ['v'] }, { frame: 'triangle', lines: ['h'] },
        { frame: 'triangle', lines: ['x', '/'] }, { frame: 'triangle', lines: ['/'] }, { frame: 'triangle', lines: ['x'] },
        { frame: 'triangle', lines: ['h', 'v', '/'] }, { frame: 'triangle', lines: ['v'] }, null
      ]
    },
    options: ['①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧'],
    optionVisualType: 'compositeShape',
    optionVisuals: [
      { composite: { frame: 'triangle', lines: ['h'] } },
      { composite: { frame: 'triangle', lines: ['/'] } },
      { composite: { frame: 'triangle', lines: ['h', 'v'] } },
      { composite: { frame: 'triangle', lines: ['h', '/'] } },
      { composite: { frame: 'square', lines: ['h', '/'] } },
      { composite: { frame: 'triangle', lines: ['x'] } },
      { composite: { frame: 'triangle', lines: ['v', '/'] } },
      { composite: { frame: 'triangle', lines: ['h', 'v', '/'] } }
    ],
    answer: 3,
    explanation: '1열에서 2열의 선을 빼는 차집합 규칙입니다. 3행은 {h,v,/} \ {v} = {h,/} 입니다.',
  },
  {
    id: 85,
    category: 'pattern',
    question: '각 행에서 2열은 1열을 90° 회전한 모양입니다. 두 도형을 합치는 규칙을 보고, 빈칸(?)에 들어갈 도형은?',
    visualType: 'compositeMatrix',
    visualData: {
      composites: [
        { frame: 'circle', lines: ['h'] }, { frame: 'circle', lines: ['v'] }, { frame: 'circle', lines: ['h', 'v'] },
        { frame: 'circle', lines: ['x'] }, { frame: 'circle', lines: ['x'] }, { frame: 'circle', lines: ['x'] },
        { frame: 'circle', lines: ['v', 'x'] }, { frame: 'circle', lines: ['h', 'x'] }, null
      ]
    },
    options: ['①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧'],
    optionVisualType: 'compositeShape',
    optionVisuals: [
      { composite: { frame: 'circle', lines: ['+', 'x'] } },
      { composite: { frame: 'circle', lines: ['h', 'v'] } },
      { composite: { frame: 'circle', lines: ['x'] } },
      { composite: { frame: 'circle', lines: ['+'] } },
      { composite: { frame: 'square', lines: ['+', 'x'] } },
      { composite: { frame: 'circle', lines: ['h', 'x'] } },
      { composite: { frame: 'circle', lines: ['v', 'x'] } },
      { composite: { frame: 'circle', lines: ['h'] } }
    ],
    answer: 0,
    explanation: '2열은 1열을 90° 회전한 모양입니다. 두 선을 모두 합치는 합집합 규칙이므로 3행은 {v,x} ∪ {h,x} = {h,v,x} = +, x 모양입니다.',
  },
  {
    id: 86,
    category: 'logic',
    question: '각 행에서 2열은 1열을 90° 회전한 모양입니다. 두 도형이 겹치는 부분이 사라지는 규칙을 보고, 빈칸(?)에 들어갈 도형은?',
    visualType: 'overlapMatrix',
    visualData: {
      cells: [
        [[1,0,0],[1,0,0],[1,0,0]],
        [[1,1,1],[0,0,0],[0,0,0]],
        [[0,1,1],[1,0,0],[1,0,0]],
        [[0,1,0],[0,1,0],[0,1,0]],
        [[0,0,0],[1,1,1],[0,0,0]],
        [[0,1,0],[1,0,1],[0,1,0]],
        [[1,0,0],[0,1,0],[0,0,1]],
        [[0,0,1],[0,1,0],[1,0,0]],
        null
      ]
    },
    options: ['①', '②', '③', '④'],
    optionVisualType: 'blockGrid',
    optionVisuals: [
      { grid: [[1,0,1],[0,0,0],[1,0,1]] },
      { grid: [[1,0,1],[0,1,0],[1,0,1]] },
      { grid: [[1,0,0],[0,0,0],[0,0,1]] },
      { grid: [[0,0,1],[0,1,0],[1,0,0]] }
    ],
    answer: 0,
    explanation: '2열은 1열을 90° 회전한 모양입니다. 두 도형이 겹치는 부분이 사라지는 XOR 규칙이므로, 3행에서 두 대각선이 겹친 가운데 칸만 사라져 X자(중심 제외)가 됩니다.',
  },
  {
    id: 87,
    category: 'logic',
    question: '각 행에서 1열에서 2열의 선을 빼는 차집합 규칙입니다. 빈칸(?)에 들어갈 도형은?',
    visualType: 'compositeMatrix',
    visualData: {
      composites: [
        { frame: 'hexagon', lines: ['h', 'v'] }, { frame: 'hexagon', lines: ['v'] }, { frame: 'hexagon', lines: ['h'] },
        { frame: 'hexagon', lines: ['x', '/'] }, { frame: 'hexagon', lines: ['/'] }, { frame: 'hexagon', lines: ['x'] },
        { frame: 'hexagon', lines: ['h', 'v', '/'] }, { frame: 'hexagon', lines: ['v'] }, null
      ]
    },
    options: ['①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧'],
    optionVisualType: 'compositeShape',
    optionVisuals: [
      { composite: { frame: 'hexagon', lines: ['h', 'v'] } },
      { composite: { frame: 'hexagon', lines: ['x'] } },
      { composite: { frame: 'hexagon', lines: ['h', '/'] } },
      { composite: { frame: 'hexagon', lines: ['/'] } },
      { composite: { frame: 'diamond', lines: ['h', '/'] } },
      { composite: { frame: 'hexagon', lines: ['h'] } },
      { composite: { frame: 'hexagon', lines: ['v', '/'] } },
      { composite: { frame: 'hexagon', lines: ['h', 'v', '/'] } }
    ],
    answer: 2,
    explanation: '1열에서 2열의 선을 빼는 차집합 규칙입니다. 3행은 {h,v,/} \ {v} = {h,/} 입니다.',
  },
  {
    id: 88,
    category: 'pattern',
    question: '각 행에서 2열은 1열을 180° 회전한 모양입니다. 두 도형을 합치는 규칙을 보고, 빈칸(?)에 들어갈 도형은?',
    visualType: 'overlapMatrix',
    visualData: {
      cells: [
        [[1,1,0],[0,0,0],[0,0,0]],
        [[0,0,0],[0,0,0],[0,1,1]],
        [[1,1,0],[0,0,0],[0,1,1]],
        [[1,0,0],[0,1,0],[0,0,1]],
        [[1,0,0],[0,1,0],[0,0,1]],
        [[1,0,0],[0,1,0],[0,0,1]],
        [[1,1,0],[1,0,0],[0,0,0]],
        [[0,0,0],[0,0,1],[0,1,1]],
        null
      ]
    },
    options: ['①', '②', '③', '④'],
    optionVisualType: 'blockGrid',
    optionVisuals: [
      { grid: [[1,1,0],[1,1,1],[0,1,1]] },
      { grid: [[1,1,0],[1,0,1],[0,1,1]] },
      { grid: [[1,1,0],[1,0,0],[0,1,1]] },
      { grid: [[0,1,1],[1,0,1],[1,1,0]] }
    ],
    answer: 1,
    explanation: '2열은 1열을 180° 회전한 모양입니다. 두 도형을 모두 합치는 합집합 규칙이므로 3행은 두 ㄱ자 도형을 합친 모양이 됩니다.',
  },
];